let temeId = localStorage.getItem('temeId'); //主题颜色ID
let isLogin = localStorage.getItem('isLogin')//是否填写
let quesType = '1'; //0：问题登记，1：更多资料，2：联系我们，3.体验
let quesTypeName = '';//0：问题登记，1：更多资料，2：联系我们，3.体验
let indexShow = localStorage.getItem('indexShow'); //导航下标全局变量
export default{
    temeId,
    isLogin,
    quesType,
    quesTypeName,
    indexShow,
}


// WEBPACK FOOTER //
// ./src/global/globalData.js